module.exports = __webpack_public_path__ + "b32c3521a672d4708df3356642eff496.pdf";